import angular from 'angular'
import './shinies.service'
import './users/users.controller'

angular
  .module('admin.shinies', ['admin.shinies.service', 'admin.shinies.users'])
  .controller('ShiniesAdminCtrl', ShiniesAdminCtrl)

/** @ngInject */
function ShiniesAdminCtrl($scope, ShiniesAdminService, EventService) {
  var vm = this
  vm.items = []
  vm.channels = []
  vm.sets = []
  vm.collectibles = []
  vm.waitChannel = true
  vm.waitSet = true
  vm.customDate = false
  vm.displayStartDate =
    moment()
      .startOf('day')
      .unix() + '000'
  vm.displayEndDate =
    moment()
      .startOf('day')
      .unix() + '000'
  vm.startDate =
    moment()
      .startOf('day')
      .unix() + '000000'
  vm.endDate =
    moment()
      .endOf('day')
      .unix() + '000000'
  vm.chId = null
  vm.setId = null
  vm.collectibleId = null
  vm.date1 = null
  vm.date2 = null

  EventService.listChannels().then(function(result) {
    vm.channels = result.results
  })

  vm.openCalendar = function(e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen = true
      vm.isOpen1 = false
    } else if (type === 2) {
      vm.isOpen = false
      vm.isOpen1 = true
    }
  }

  vm.filterDate = function(key) {
    vm.customDate = false
    switch (key) {
      case 'today':
        vm.startDate =
          moment()
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      case '7days':
        vm.startDate =
          moment()
            .subtract(7, 'days')
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .subtract(7, 'days')
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      case '15days':
        vm.startDate =
          moment()
            .subtract(15, 'days')
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .subtract(15, 'days')
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      case '30days':
        vm.startDate =
          moment()
            .subtract(30, 'days')
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .subtract(30, 'days')
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      default:
        vm.startDate =
          moment()
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
    }
  }

  vm.selectCustomDate = function() {
    vm.customDate = !vm.customDate
    vm.startDate = null
    vm.endDate = null
    vm.displayStartDate = null
    vm.displayEndDate = null
  }

  vm.load = function() {
    if (vm.customDate) {
      if (!vm.date1 || !vm.date2) {
        swal('Must choose dates', '', 'error')
        return
      }

      vm.startDate = moment(vm.date1).unix() + '000000'
      vm.displayStartDate = moment(vm.date1).unix() + '000'
      vm.endDate = moment(vm.date2).unix() + '000000'
      vm.displayEndDate = moment(vm.date2).unix() + '000'
    }

    vm.items = []

    var chId = !vm.chId ? '' : vm.chId
    var setId = !vm.setId ? '' : vm.setId
    var collectibleId = !vm.collectibleId ? '' : vm.collectibleId

    ShiniesAdminService.list(vm.startDate, vm.endDate, chId, setId, collectibleId).then(function(result) {
      vm.items = result.results
    })
  }

  vm.load()

  vm.clear = function() {
    vm.displayStartDate =
      moment()
        .startOf('day')
        .unix() + '000'
    vm.displayEndDate =
      moment()
        .startOf('day')
        .unix() + '000'
    vm.startDate =
      moment()
        .startOf('day')
        .unix() + '000000'
    vm.endDate =
      moment()
        .endOf('day')
        .unix() + '000000'
    vm.chId = null
    vm.setId = null
    vm.collectibleId = null
    vm.sets = []
    vm.collectibles = []
    vm.date1 = null
    vm.date2 = null
    vm.waitChannel = true
    vm.waitSet = true
    vm.customDate = false
  }

  var watch = $scope.$watch('vm.chId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    EventService.listSets(newVal).then(function(response) {
      vm.sets = response.results
      vm.waitChannel = false
      vm.waitSet = true
      vm.collectibles = []
    })
  })

  var watch1 = $scope.$watch('vm.setId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    vm.waitSet = false
    EventService.listCollectibles(vm.setId).then(function(response) {
      vm.collectibles = response.results
      vm.waitSet = false
    })
  })

  $scope.$on('$destroy', function() {
    watch()
    watch1()
  })
}
